import { Children } from 'react';

import { withSpinner } from '../../Spinner';

function AppView({ children }) {
  return Children.only(children);
}

export default withSpinner(AppView);



// WEBPACK FOOTER //
// ./src/app/components/Initializer/components/View.js